import AuctionsListing from '../../../components/AuctionsListing/AuctionsListing'
import getAuctions from '../../../api/getAuctions'
import redirectAuctionsByFavoriteLocation from '@utilities/redirects/redirectAuctionsByFavoriteLocation'

export async function getServerSideProps(context: any) {
  const route = 'past-auctions'

  const redirect = await redirectAuctionsByFavoriteLocation(context, route)
  if (redirect) return redirect

  const auctions = await getAuctions(context, route)
  return { props: auctions }
}

export default function PastAuctions(props: any) {
  return (
    <AuctionsListing
      props={props}
      title="Past Online Auctions by BidFTA.com"
      previewDescription="View all past online auctions powered by BidFTA. With products from major retailers ranging from overstock items and customer returns."
      baseUrl="/past-auctions"
    />
  )
}
